import * as React from 'react';

interface IProps {
	steps: string[];
	active: number;
	goTo?: (step: number) => void;
	disabledSteps?: number[];
	lastEnabledStep?: number;
	fromBookingProcess?: boolean;
	/**
	 * hide checkmarks
	 */
	dontRenderDone?: boolean;
	/**
	 * disable row navbar on mobile
	 */
	forceWrap?: boolean;
	customClass?: string;
}

class WizardSideNav extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.renderStep = this.renderStep.bind(this);

		this.activeRef = React.createRef();
	}

	private activeRef;

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (prevProps.active != this.props.active) {
			setTimeout(() => {
				this.activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
			}, 100);
		}
	}

	private renderStep(text: string, step: number) {
		const { active, goTo, disabledSteps, lastEnabledStep, dontRenderDone, fromBookingProcess } = this.props;

		const isFromBookingProcess = fromBookingProcess ? true : false;

		if (text == null) return;

		const attrs: React.DetailedHTMLProps<React.HTMLAttributes<HTMLLIElement>, HTMLLIElement> = {
			className: '',
		};
		if (Number(active) === step) {
			attrs.className += ' active';
			attrs.ref = this.activeRef;
		}
		let canNavigate = typeof goTo === 'function';
		if (canNavigate && disabledSteps && Array.isArray(disabledSteps) && disabledSteps.indexOf(step) !== -1) {
			canNavigate = false;
		}
		if (canNavigate && lastEnabledStep !== undefined && lastEnabledStep < step) {
			canNavigate = false;
		}
		if (canNavigate) {
			attrs.onClick = () => goTo(step);
			attrs.className += ' enabled';
		}
		let done: JSX.Element = null;
		if (!isFromBookingProcess && active > step && !dontRenderDone) {
			done = <img className="done" src={require('containers/Html/icons/step_check.svg')} />;
		}
		return (
			<li key={step} {...attrs}>
				{done}
				{text}
			</li>
		);
	}

	public render() {
		const { steps, customClass } = this.props;
		return (
			<div className={`sidemenu ${this.props.forceWrap ? ' force-wrap' : ''} ${customClass}`}>
				<ul>{steps.map(this.renderStep)}</ul>
			</div>
		);
	}
}

export { WizardSideNav };
